import React, { useEffect, useState } from 'react'
import { filters as StaticFacets } from '../../assets/data/search'
import styles from './style.module.css' 


const BucketFilters = (props: {[key: string]: any}) => {

    const [types, setTypes] = useState<any[]>([])
    const { filters } = props

    useEffect(() => {
        if(filters && Object.keys(filters).length) {
            getFileType(filters)
        }
    }, [filters])

    /**
     * Function to get the filters applied for this subscription bucket
     */
     const getFileType = (filters: {[key: string]: any}) => {
        let bucketList: {[key: string]: any} = {}
        Object.keys(filters).map((filtersSlug: string) => {
            StaticFacets.filter(staticFacet => {
                if(staticFacet.slug === filtersSlug) {

                    // Get parameter name
                    let parameters: any[] = []
                    if(staticFacet.parameters && staticFacet.parameters.length) {
                        staticFacet.parameters.filter(staticParameter =>  {
                            if(filters[filtersSlug].indexOf(staticParameter.slug) != -1) {
                                parameters.push(staticParameter.title)
                            }
                        })
                    } else {
                        parameters.push(filters[filtersSlug])
                    }
                    bucketList[staticFacet.title] = parameters
                }
            })
            if(filtersSlug === 'keywords') {
                bucketList['Keywords'] = filters[filtersSlug]
            }
        })
        let updatedFilters = Object.keys(bucketList).map((filter: any) => {
            return  <><span className={styles.filterTitle}>{filter}: </span><span>{bucketList[filter].join(', ')}</span></>

        })

        setTypes(updatedFilters)
    }

    return (
        types && types.length > 0 ?
        <ul className={`${styles.filters} list-unstyled`}>
            { types.map((type, i) => <li key={`filter-${i}`}>{type}</li>) }
        </ul> :
        null
    )
}

export default BucketFilters
